import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

const CheckIcon = forwardRef<any, any>((props, ref) => {
  const { color, ...rest } = props;
  const colorMap = {
    white: "#F2F2F2",
  };
  const fillColor = colorMap[color] || color || "inherit";

  return (
    <Icon color={fillColor} {...rest} ref={ref}>
      <path
        fill={fillColor}
        clipRule="evenodd"
        d="M14.3789 1.91289L5.55087 11.8252L2.42262 8.31276C2.05118 7.8957 1.4508 7.8957 1.07936 8.31276C0.707922 8.72982 0.707922 9.40393 1.07936 9.82099L4.87924 14.0876C5.06449 14.2956 5.30768 14.4001 5.55087 14.4001C5.79406 14.4001 6.03726 14.2956 6.2225 14.0876L15.7222 3.42113C16.0936 3.00407 16.0936 2.32995 15.7222 1.91289C15.3508 1.49583 14.7504 1.49583 14.3789 1.91289V1.91289Z"
        fillRule="evenodd"
      />
    </Icon>
  );
});

export { CheckIcon };
